export default __webpack_public_path__ + "static/media/Print-1953.432e1346.jpg";